'use strict';

angular.module('app.newMention', [])

    .controller('NewMentionCtrl', function ($scope, $rootScope, $http, $log, $location, localStorageService, mention, mentiontype, language, $modalInstance, $modal, mentionManagementService, TRACK_EVENTS) {

        $scope.mention = {
            keyword: mention
        };

        var definitions = angular.copy($rootScope.definitions);
        $scope.type = definitions.type;
        $scope.verticals = definitions.verticals;
        $scope.topics = definitions.topics;

        angular.forEach($scope.type, function (item, index) {
            if (item.id == mentiontype)
                $scope.type[index].ticked = true;
        });

        $scope.allLanguage = [];

        // Hashtag and Url should be global, or keyword for multiple countries should be globally as well
        if ((mentiontype != 1) || (mentiontype == 1 && language === -1)) {
            $scope.allLanguage.push({
                id: 0,
                name: 'Global',
                ticked: false
            });
            $scope.allLanguage[0].ticked = true;
        } else {
            if(language > 0 || language.length > 1) {
                $scope.allLanguage.push({
                    id: 0,
                    name: 'Global',
                    ticked: false
                });
            }

            mentionManagementService.getLanguagesOfInterestingCountries(false)
                .then(function (response) {
                    angular.forEach(response.data, function (item) {
                        // Language of selected country (in the case of single country)
                        if(language > 0 || language.length > 1) {
                            if (language > 0) {
                                if( language === item.id) {
                                    item.ticked = false;
                                    $scope.allLanguage.push(item);    
                                }
                            }
                            if (language.length > 1) {
                                for (var i=0; i<language.length; i++) {
                                    if ( language[i] === item.id ) {
                                        item.ticked = false;
                                        $scope.allLanguage.push(item);
                                    }   
                                }
                            }
                        } else {
                            $scope.allLanguage.push(item);
                        }
                    });
                }, function (response) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
                })
        }

        $scope.selectKeywordType = function (e) {
            $scope.selectedKeywordType = e.id;
        }

        $scope.selectVertical = function (e) {
            $scope.selectedVertical = e.id;
        }

        $scope.selectTopic = function (e) {
            $scope.selectedTopic = e.id;
        }

        $scope.save = function (isValid) {
            $scope.selectedLanguage = [];

            $scope.allLanguage.forEach(function (val) {
                if (val.ticked == true)
                    $scope.selectedLanguage.push(val.id)
            })

            var req_addNewmention = {
                url: $rootScope.apiUrl + 'mention/addNewProjectMention',
                method: 'POST',
                data: {
                    keyword: mention,
                    keywordType: parseInt(mentiontype),
                    languages: $scope.selectedLanguage,
                    vertical_id: $scope.selectedVertical,
                    topic_id: $scope.selectedTopic
                }
            }

            $http(req_addNewmention).success(function (response) {
                    // Mixpanel tracking create mention
                    analytics.track(
                        TRACK_EVENTS.CREATE_MENTION.EVT_NAME,
                        {
                            "action": "Create",
                            "item": TRACK_EVENTS.CREATE_MENTION.ITEM_NAME,
                            "target_type": definitions.type[req_addNewmention.data.keywordType - 1].name,
                            "target_name": req_addNewmention.data.keyword,
                            "target_id": response.mention.id,
                            "params": req_addNewmention.data
                        }
                    );

                    $scope.languageList = [];
                    angular.forEach(response.mention.languages, function (language) {
                        $scope.languageList.push(language.id);
                    })
                    var existMention = {
                        id: response.mention.id,
                        keywordType: response.mention.keywordType.id,
                        keyword: response.mention.keyword,
                        languages: $scope.languageList,
                        topic_id: response.mention.topic[0].id,
                        vertical_id: response.mention.vertical[0].id,
                        status: response.mention.status
                    }
                    $modalInstance.close({
                        newMention: existMention
                    });
                })
                .error(function (response) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
                })
        }
    })